import { IReduxState } from '../../../../types/redux';

export function priceGteSelector(state: IReduxState): number | undefined {
  return state.filters.jsonQuery.price?.value.gte;
}
